import API from '@/api'
export default {
  computed: {
    isPC() {
      return typeof this.$store.state.isPC === 'boolean' ? this.$store.state.isPC : true
    }
  },
  methods: {
    /**
     * 跳转到商品详情  格式化路由
     * @param {*} id // 商品id kkProductId
     * @param {*} color // 商品指定颜色
     * @param {*} warehouse // 商品指定仓库
     * @param {*} noChangeWarehouse // 商品禁止选择仓库
     */
    jumpDetailSeo(id, color, warehouse, noChangeWarehouse) {
      API.getSeoBusinessId({
        businessId: id,
        type: 3
      }).then(res => {
        if (res.code !== 10000) {
          return this.$message.warning(res.message)
        }
        if (!res.data || !res.data.seoSearchTerm) {
          return this.$message.warning(this.$t('Components.Product.DetailHint'))
        }
        // 2024.8.31 调整
        // let diagonalidx = res.data.seoSearchTerm.slice(1, res.data.seoSearchTerm.length).indexOf('/')
        // let firstCategory = res.data.seoSearchTerm.slice(1, diagonalidx + 1)
        // let secondLevel = res.data.seoSearchTerm.slice(diagonalidx + 1, res.data.seoSearchTerm.length)
        // let path = `${firstCategory}${secondLevel}`
        let path = res.data.seoSearchTerm
        if (color) path += `?color=${color}`
        if (warehouse) {
          path += `${path.includes('?') ? '&' : '?'}warehouse=${warehouse}`
        }
        if (noChangeWarehouse) {
          path += `${path.includes('?') ? '&' : '?'}noChangeWarehouse=1`
        }
        if (navigator.userAgent.includes('Mobile')) {
          location.href = path
        } else {
          window.open(path)
        }
      })
    }
  }
}
